// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3_jO-","rootSmall":"AddTileButton_rootSmall__3EJL-"};